const provider = function() {
	'use strict';
	var _ttl = {
		success: 2000,
		error: null,
		warning: null,
		info: 2000
	}, 
	_messagesKey = 'messages', 
	_messageTextKey = 'text', 
	_messageTitleKey = 'title', 
	_messageSeverityKey = 'severity', 
	_messageTTLKey = 'ttl', 
	_onlyUniqueMessages = false, 
	_messageVariableKey = 'variables', 
	_referenceId = 0, 
	_inline = false, 
	_position = 'top-right', 
	_disableCloseButton = false, 
	_disableIcons = false, 
	_reverseOrder = false, 
	_disableCountDown = false, 
	_translateMessages = false;

	this.globalTimeToLive = function (ttl) {
		if (typeof ttl === 'object') {
			for (var k in ttl) {
				if (ttl.hasOwnProperty(k)) {
					_ttl[k] = ttl[k];
				}
			}
		} else {
			for (var severity in _ttl) {
				if (_ttl.hasOwnProperty(severity)) {
					_ttl[severity] = ttl;
				}
			}
		}
		return this;
	};
	this.globalTranslateMessages = function (translateMessages) {
		_translateMessages = translateMessages;
		return this;
	};
	this.globalDisableCloseButton = function (disableCloseButton) {
		_disableCloseButton = disableCloseButton;
		return this;
	};
	this.globalDisableIcons = function (disableIcons) {
		_disableIcons = disableIcons;
		return this;
	};
	this.globalReversedOrder = function (reverseOrder) {
		_reverseOrder = reverseOrder;
		return this;
	};
	this.globalDisableCountDown = function (countDown) {
		_disableCountDown = countDown;
		return this;
	};
	this.messageVariableKey = function (messageVariableKey) {
		_messageVariableKey = messageVariableKey;
		return this;
	};
	this.globalInlineMessages = function (inline) {
		_inline = inline;
		return this;
	};
	this.globalPosition = function (position) {
		_position = position;
		return this;
	};
	this.messagesKey = function (messagesKey) {
		_messagesKey = messagesKey;
		return this;
	};
	this.messageTextKey = function (messageTextKey) {
		_messageTextKey = messageTextKey;
		return this;
	};
	this.messageTitleKey = function (messageTitleKey) {
		_messageTitleKey = messageTitleKey;
		return this;
	};
	this.messageSeverityKey = function (messageSeverityKey) {
		_messageSeverityKey = messageSeverityKey;
		return this;
	};
	this.messageTTLKey = function (messageTTLKey) {
		_messageTTLKey = messageTTLKey;
		return this;
	};
	this.onlyUniqueMessages = function (onlyUniqueMessages) {
		_onlyUniqueMessages = onlyUniqueMessages;
		return this;
	};
	this.serverMessagesInterceptor = function ($q, growl) {
		"ngInject"

		function checkResponse(response) {
			if (response !== undefined && response.data && response.data[_messagesKey] && response.data[_messagesKey].length > 0) {
				growl.addServerMessages(response.data[_messagesKey]);
			}
		}
		return {
			'response': function (response) {
				checkResponse(response);
				return response;
			},
			'responseError': function (rejection) {
				checkResponse(rejection);
				return $q.reject(rejection);
			}
		};
	};
	
	this.$get = function ($rootScope, $interpolate, $sce, $filter, $interval, growlMessages) {
		"ngInject"

		var translate;
		growlMessages.onlyUnique = _onlyUniqueMessages;
		growlMessages.reverseOrder = _reverseOrder;
		try {
			translate = $filter('translate');
		} catch (e) {
		}
		function broadcastMessage(message) {
			if (translate && message.translateMessage) {
				message.text = translate(message.text, message.variables) || message.text;
				message.title = translate(message.title) || message.title;
			} else {
				var polation = $interpolate(message.text);
				message.text = polation(message.variables);
			}
			var addedMessage = growlMessages.addMessage(message);
			$rootScope.$broadcast('growlMessage', message);
			$interval(function () {
			}, 0, 1);
			return addedMessage;
		}
		function sendMessage(text, config, severity) {
			var _config = config || {}, message;
			message = {
				text: text,
				title: _config.title,
				severity: severity,
				ttl: _config.ttl || _ttl[severity],
				variables: _config.variables || {},
				disableCloseButton: _config.disableCloseButton === undefined ? _disableCloseButton : _config.disableCloseButton,
				disableIcons: _config.disableIcons === undefined ? _disableIcons : _config.disableIcons,
				disableCountDown: _config.disableCountDown === undefined ? _disableCountDown : _config.disableCountDown,
				position: _config.position || _position,
				referenceId: _config.referenceId || _referenceId,
				translateMessage: _config.translateMessage === undefined ? _translateMessages : _config.translateMessage,
				destroy: function () {
					growlMessages.deleteMessage(message);
				},
				setText: function (newText) {
					message.text = $sce.trustAsHtml(String(newText));
				},
				onclose: _config.onclose,
				onopen: _config.onopen
			};
			return broadcastMessage(message);
		}
		function warning(text, config) {
			return sendMessage(text, config, 'warning');
		}
		function error(text, config) {
			return sendMessage(text, config, 'error');
		}
		function info(text, config) {
			return sendMessage(text, config, 'info');
		}
		function success(text, config) {
			return sendMessage(text, config, 'success');
		}
		function general(text, config, severity) {
			severity = (severity || 'error').toLowerCase();
			return sendMessage(text, config, severity);
		}
		function addServerMessages(messages) {
			if (!messages || !messages.length) {
				return;
			}
			var i, message, severity, length;
			length = messages.length;
			for (i = 0; i < length; i++) {
				message = messages[i];
				if (message[_messageTextKey]) {
					severity = (message[_messageSeverityKey] || 'error').toLowerCase();
					var config = {};
					config.variables = message[_messageVariableKey] || {};
					config.title = message[_messageTitleKey];
					if (message[_messageTTLKey]) {
						config.ttl = message[_messageTTLKey];
					}
					sendMessage(message[_messageTextKey], config, severity);
				}
			}
		}
		function onlyUnique() {
			return _onlyUniqueMessages;
		}
		function reverseOrder() {
			return _reverseOrder;
		}
		function inlineMessages() {
			return _inline;
		}
		function position() {
			return _position;
		}
		return {
			warning: warning,
			error: error,
			info: info,
			success: success,
			general: general,
			addServerMessages: addServerMessages,
			onlyUnique: onlyUnique,
			reverseOrder: reverseOrder,
			inlineMessages: inlineMessages,
			position: position
		};
	}
}

export default provider;


// WEBPACK FOOTER //
// ./app/components/growl/growl.provider.js